(function ($) {
  DJ.addBehavior('saveForm', '.save-form', {
    attach: function () {
      const button = this;
      const buttonContainer = document.querySelector('.layout-pages__inner');
      const header = document.querySelector('.header');

      /**
       * Return false if no button container and header.
       */
      if (!buttonContainer || !header) {
        return false;
      }

      /**
       * Set styles for an element.
       * @param element
       *  Element for which need to set styles.
       * @param {Object} styles
       *  Object with the styles to set.
       */
      const setStylesOnElement = (element, styles) => {
        Object.assign(element.style, styles);
      };

      /**
       * Toggle fixed position for the button to emulate a sticky behavior
       * inside the needed container.
       */
      const toggleFixedPosition = () => {
        const buttonContainerTop = buttonContainer.offsetTop;
        const buttonContainerHeight = buttonContainer.offsetHeight;
        const headerBottom = header.offsetTop + header.offsetHeight;

        if (window.pageYOffset + headerBottom >= buttonContainerTop) {
          setStylesOnElement(button, {
            position: 'fixed',
            top: `${headerBottom + 23}px`,
            right: `${window.innerWidth - (buttonContainer.offsetLeft + buttonContainer.offsetWidth - 8)}px`
          });
        } else {
          setStylesOnElement(button, {
            position: 'absolute',
            top: '',
            right: ''
          });
        }

        if (window.pageYOffset + headerBottom + button.offsetHeight + 23
          >= buttonContainerTop + buttonContainerHeight) {
          setStylesOnElement(button, {
            position: 'absolute',
            top: 'auto',
            bottom: '23px',
            right: ''
          });
        }
      };

      /**
       * Call toggleFixedPosition() on window scroll.
       */
      window.addEventListener('scroll', () => {
        toggleFixedPosition();
      });

      /**
       * Call toggleFixedPosition() on window resize.
       */
      window.addEventListener('resize', () => {
        toggleFixedPosition();
      });

      return toggleFixedPosition();
    }
  });
})(jQuery);
